export default __webpack_public_path__ + "static/media/slider3.3ddc6e7c.jpg";